import { Types } from "../actions/adventCalendarActions";
import _ from "lodash";

const adventCalendarReducers = (state, action) => {
	switch (action.type) {
		case Types.ADVENT_CALENDAR_SET_MODAL: {
			let newState = _.cloneDeep(state);
			newState.adventCalendar.modal = action.value;
			return newState;
		}
		case Types.ADVENT_CALENDAR_NOTIFICATION_ADD: {

			let newState = { ...state };

			newState.adventCalendar.notifications.push({ ...action.notification });

			newState.adventCalendar.notifications = [...newState.adventCalendar.notifications];

			return newState;
		}
		case Types.ADVENT_CALENDAR_NOTIFICATION_CLOSE: {

			let newState = { ...state };

			const indexToRemove = newState.adventCalendar.notifications.findIndex(item => item.id == action.id);

			if (indexToRemove >= 0) {
				newState.adventCalendar.notifications.splice(indexToRemove, 1);
			}

			newState.adventCalendar.notifications = [...newState.adventCalendar.notifications];

			return newState;
		}
		case Types.ADVENT_CALENDAR_LOADING_GIFTS: {
			let newState = _.cloneDeep(state);
			newState.adventCalendar.loadingMy = action.status;
			return newState;
		}
		case Types.ADVENT_CALENDAR_LOADED_GIFTS: {
			let newState = _.cloneDeep(state);
			newState.adventCalendar.myGifts = action.items;
			return newState;
		}
		case Types.ADVENT_CALENDAR_LOADING_RECENT_GIFTS: {
			let newState = _.cloneDeep(state);
			newState.adventCalendar.loadingRecent = action.status;
			return newState;
		}
		case Types.ADVENT_CALENDAR_LOADED_RECENT_GIFTS: {
			let newState = _.cloneDeep(state);
			newState.adventCalendar.lastGifted = action.payload.lastGifted;
			newState.adventCalendar.items = action.payload.items;
			newState.adventCalendar.numberOfItemsOpened = action.payload.numOfItemsOpened;
			return newState;
		}
		case Types.ADVENT_CALENDAR_SAVING_GIFT: {
			let newState = _.cloneDeep(state);
			newState.adventCalendar.savingUserGift = action.status;
			return newState;
		}
		case Types.ADVENT_CALENDAR_SET_TERMS_MODAL: {
			let newState = _.cloneDeep(state);
			newState.adventCalendar.termsModal = action.value;
			return newState;
		}
		case Types.ADVENT_CALENDAR_SET_SIGNIN_MODAL: {
			let newState = _.cloneDeep(state);
			newState.adventCalendar.signInModal = action.value;
			return newState;
		}
		default:
			return state;
	}
};

export default adventCalendarReducers;
